import PropTypes from 'prop-types';
import React from 'react';
import Waypoint from 'react-waypoint';
import connectToStores from 'fluxible-addons-react/connectToStores';

import Section from 'common/components/Section';
import SectionDivider from 'common/components/SectionDivider';
import BasicsStep from 'book-calculator/components/BasicsStep';
import EditingStep from 'book-calculator/components/EditingStep';
import CoverStep from 'book-calculator/components/CoverStep';
import InteriorStep from 'book-calculator/components/InteriorStep';
import PrintingStep from 'book-calculator/components/PrintingStep';
import ExtrasStep from 'book-calculator/components/ExtrasStep';
import Summary from 'book-calculator/containers/Summary';
import Overview from 'book-calculator/containers/Overview';
import BookCalculatorAttributesStore from 'book-calculator/stores/BookCalculatorAttributesStore';

class BookCalculator extends React.Component {
    constructor(props) {
        super();

        this.handleEditingStepSeen = this.handleStepSeen.bind(this, 'seenEditingStep');
        this.handleCoverStepSeen = this.handleStepSeen.bind(this, 'seenCoverStep');
        this.handleInteriorStepSeen = this.handleStepSeen.bind(this, 'seenInteriorStep');
        this.handlePrintingStepSeen = this.handleStepSeen.bind(this, 'seenPrintingStep');
        this.handleExtrasStepSeen = this.handleStepSeen.bind(this, 'seenExtrasStep');

        this.state = {
            seenEditingStep: false,
            seenCoverStep: false,
            seenInteriorStep: false,
            seenPrintingStep: false,
            seenExtrasStep: false,
        };
    }

    render() {
        const { bookType } = this.props;
        const showPrintingStep = bookType !== 'ebook';
        const {
            seenEditingStep,
            seenCoverStep,
            seenInteriorStep,
            seenPrintingStep,
            seenExtrasStep,
        } = this.state;

        return (
            <div className="book-calculator-app">
                <div className="book-calculator-app__overview">
                    <Overview
                        seenSteps={{
                            editingStep: seenEditingStep,
                            coverStep: seenCoverStep,
                            interiorStep: seenInteriorStep,
                            printingStep: seenPrintingStep,
                            extrasStep: seenExtrasStep,
                        }}
                        canRenderPrinting={showPrintingStep}
                    />
                </div>
                <div className="book-calculator-app__steps">
                    <Section id="book-calculator-basics-step" variations={['collapse-bottom']}>
                        <BasicsStep step={1} />
                    </Section>
                    <Section id="book-calculator-editing-step">
                        <Waypoint onPositionChange={this.handleEditingStepSeen} />
                        <EditingStep step={2} />
                    </Section>
                    <Section id="book-calculator-cover-step" variations={['collapse-bottom']}>
                        <Waypoint onPositionChange={this.handleCoverStepSeen} />
                        <CoverStep step={3} />
                    </Section>
                    <Section id="book-calculator-interior-step" variations={['collapse-bottom']}>
                        <Waypoint onPositionChange={this.handleInteriorStepSeen} />
                        <InteriorStep step={4} />
                    </Section>

                    {showPrintingStep ? this.renderPrintingStep() : null}

                    <Section id="book-calculator-extras-step">
                        <Waypoint onPositionChange={this.handleExtrasStepSeen} />
                        <ExtrasStep step={showPrintingStep ? 6 : 5} />
                    </Section>
                    <SectionDivider />
                    <Section id="book-calculator-summary">
                        <Summary />
                    </Section>
                </div>
            </div>
        );
    }

    renderPrintingStep() {
        return (
            <Section id="book-calculator-printing-step" variations={['collapse-bottom']}>
                <Waypoint onPositionChange={this.handlePrintingStepSeen} />
                <PrintingStep step={5} />
            </Section>
        );
    }

    handleStepSeen(key, waypointEvent) {
        const { currentPosition } = waypointEvent;

        if (currentPosition === 'inside' || currentPosition === 'above') {
            this.setState({
                [key]: true,
            });
        }
    }
}

BookCalculator.propTypes = {
    bookType: PropTypes.string.isRequired,
};

export default connectToStores(BookCalculator, [BookCalculatorAttributesStore], (context, prop) => {
    const attributes = context.getStore(BookCalculatorAttributesStore).getState();

    return {
        bookType: attributes['book_type'],
    };
});
